import { useEffect, useMemo, useCallback } from 'react';

export const SEO = ({ title, description }) => {
  const fullTitle = useMemo(
    () => title ? `${title} | Surfside Patrol` : 'Surfside Patrol | Professional Security Services',
    [title]
  );

  const updateMeta = useCallback((selector, attribute, value) => {
    if (!value) return;
    const el = document.querySelector(selector);
    if (el) el.setAttribute(attribute, value);
  }, []);

  useEffect(() => {
    document.title = fullTitle;

    updateMeta('meta[name="description"]', 'content', description);
    updateMeta('meta[property="og:title"]', 'content', fullTitle);
    updateMeta('meta[property="og:description"]', 'content', description);
    updateMeta('meta[name="twitter:title"]', 'content', fullTitle);
    updateMeta('meta[name="twitter:description"]', 'content', description);
  }, [fullTitle, description, updateMeta]);

  return null;
};
